<template>
    <div class="app-container">
      <list ref="list">
        <template slot="toolbar-right">
          <el-button size="mini" type="primary" plain  v-if="$permission.canWrite()"  @click="onExport">导出</el-button>
            <el-button size="mini" type="success" plain  v-if="$permission.canWrite()"  @click="onImport">导入</el-button>
          <el-button size="mini" type="primary" v-if="$permission.canWrite()" @click="create" icon="el-icon-plus">添加</el-button>
         
          <el-button size="mini" type="danger" v-if="$permission.canDel()" @click="delRows">删除</el-button>
          
        </template>
        <template slot="column">
          <el-table-column label="操作" fixed="right" align="center" width="80">
            <template slot-scope="{row}">
              <el-button type="text" icon="el-icon-edit" @click="editById(row.RecordId)" ></el-button>
              <el-button type="text" icon="el-icon-delete" @click="del(row.RecordId)" v-if="$permission.canDel()"></el-button>
            </template>
          </el-table-column>
        </template> 
      </list>
      <edit-dialog ref="editDialog" @close-saved="reload" />
      <import-dialog ref="importDialog" @upload-success="reload" />
    </div>
  </template>
  <script>
  import curdMixins from "@/mixins/curd";
  import list from "@/components/goods/infobonded/list";
  import editDialog from "@/components/goods/infobonded/editDialog";
  import importDialog from "@/components/goods/infobonded/importDialog";
  
  export default {
    name: "infobonded",
    mixins: [curdMixins],
    components: {
      list,
      editDialog,
      importDialog,
    },
    methods: {
      del(id) {
        this.$confirm("确认删除数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$refs.list.delRange([id]);
          })
          .catch(() => {});
      },
      delRows() {
        let rows = this.$refs.list.getCheckedRows();
        if (rows.length == 0) {
          this.$message.warning("请选择要删除的数据");
          return;
        }
        this.$confirm("确认删除所选的数据吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let ids = rows.map((item) => {
              return item.RecordId;
            });
            this.$refs.list.delRange(ids);
          })
          .catch(() => {});
      },
    onImport() {
      this.$refs.importDialog.open();
    },
  
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => { });
    },
    },
  };
  </script>